export default __webpack_public_path__ + "static/media/wireframes_tutorial_2.52135b77.png";